import {Accordion, AccordionDetails, AccordionSummary, Box, Link, Typography} from "@mui/material";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {StateData} from "../../fstn/state";
import {IVersion} from "./Revisions";
import {connect} from "react-redux";
import {updateFocus, updateMode} from "../../redux/slices/editor";
import {RevisionDetails} from "./RevisionDetails";
import StateLock from "../navbar/StateLock";

const useStyles = makeStyles((theme) => ({
    columnDate: {
        width: 160
    },
    columnKey: {
        width: 320,
        overflowX: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    columnName: {
        flexGrow: 1
    },
}));

interface IRevision {
    expanded: string
    project: string
    setExpanded: (key: string) => void
    state?: StateData
    stateKey: string
    updateFocus: (focus: string) => void
    updateMode: (mode: string) => void
    versions: {[key: string]: IVersion}
}
function Revision({expanded, project, setExpanded, state, stateKey, updateFocus, updateMode, versions}: IRevision) {
    const classes = useStyles();
    const handleLinkClick = (key: string) => () => {
        updateFocus(key);
        updateMode("graph");
    };

    return (
        <Accordion expanded={expanded === stateKey} TransitionProps={{unmountOnExit: true}}
                   onChange={() => setExpanded(expanded === stateKey ? "" : stateKey)}>
            <AccordionSummary sx={{flexGrow: 1}}>
                <Box display="flex" flexGrow={1} key={stateKey}>
                    <Typography className={classes.columnName}>
                        {state?.name || "Deleted"}
                    </Typography>
                    <Box display="flex" className={classes.columnKey}>
                        <StateLock project={project} size="small" state={stateKey}/>
                        <Link onClick={handleLinkClick(stateKey)}
                              title={stateKey}
                              variant="body1" sx={{cursor: "pointer"}}>
                            {stateKey}
                        </Link>
                    </Box>
                    <Typography className={classes.columnDate}>
                        {new Date(Object.values(versions)[0]?.created * 1000).toLocaleString()}
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <RevisionDetails project={project} stateKey={stateKey} versions={versions}/>
            </AccordionDetails>
        </Accordion>
    );
}
const mapStateToProps = (store: never) => ({
});

const connected = connect(mapStateToProps, {
    updateFocus,
    updateMode
})(Revision);

export {connected as Revision};